import { gql, useQuery } from "@apollo/client";
import {
  FindOfferPointsDeductionByIdQueryQuery,
  FindOfferPointsDeductionByIdQueryQueryVariables,
} from "../../../../../schemaTypes";

export const findOfferPointsDeductionByIdQuery = gql`
  query FindOfferPointsDeductionByIdQuery($id: String!) {
    findOfferPointsDeductionById(id: $id) {
      id
      offerId
      offerTitle
      offerStatus
      partnerName
      point
      createdAt
      updatedAt
      adminName
      adminLevel
    }
  }
`;

export interface WithFindOfferPointsDeductionById {
  id: string;
  offerId: string;
  offerTitle: string;
  offerStatus: string;
  partnerName: string;
  point: number;
  createdAt: string;
  updatedAt: string;
  adminName: string;
  adminLevel: string;
  loading: boolean;
}

interface Props {
  id: string;
  children: (data: WithFindOfferPointsDeductionById) => React.ReactElement | null;
}

export const FindOfferPointsDeductionByIdController: React.FC<Props> = ({
  id,
  children,
}) => {
  const { data, loading } = useQuery<
    FindOfferPointsDeductionByIdQueryQuery,
    FindOfferPointsDeductionByIdQueryQueryVariables
  >(findOfferPointsDeductionByIdQuery, {
    variables: { id },
  });

  const deduction = data?.findOfferPointsDeductionById;

  return children({
    id: deduction?.id || "",
    offerId: deduction?.offerId || "",
    offerTitle: deduction?.offerTitle || "",
    offerStatus: deduction?.offerStatus || "",
    partnerName: deduction?.partnerName || "",
    point: deduction?.point || 0,
    createdAt: deduction?.createdAt || "",
    updatedAt: deduction?.updatedAt || "",
    adminName: deduction?.adminName || "",
    adminLevel: deduction?.adminLevel || "",
    loading,
  });
};
